var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var { COLORS, classify, makeTranslate, formatStyle } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");

// Render a stacked bar chart.
module.exports = function(config) {
  // Setup
  var { labelColumn, nameColumn } = config;

  var barHeight = 55;
  var barGap = 5;
  var labelWidth = 90;
  var labelWidthEnd = 40;
  var labelMargin = 6;
  var valueGap = 6;
  var totalGap = 15;
  var spacer = 10;

  var margins = {
    top: 5,
    right: 85,
    bottom: 20,
    left: labelWidth + labelMargin
  };

  var ticksX = 4;
  var roundTicksFactor = 100;

  if (isMobile.matches) {
    ticksX = 3;
    // margins.right = 30;
  }

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = (barHeight + barGap) * config.data.length + spacer;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  var values = config.data.map(d => d.values[d.values.length - 1].x1);
  var floors = values.map(
    v => v
  );
  var ceilings = values.map(
    v => v
  );

  var min = Math.min(...floors);
  var max = 120;

  if (min > 0) {
    min = 0;
  }

  var xScale = d3
    .scaleLinear()
    .domain([min, max])
    .rangeRound([0, chartWidth]);

  var colorScale = d3
    .scaleOrdinal()
    .domain(config.data[0].values.map(d => d[nameColumn]))
      .range([COLORS.teal2, COLORS.teal3, COLORS.teal4, COLORS.teal5, COLORS.orange5]);

  // Render the legend.
  var legend = containerElement
    .append("ul")
    .attr("class", "key")
    .selectAll("g")
    .data(colorScale.domain())
    .enter()
    .append("li")
    .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);

  legend.append("b").style("background-color", colorScale);

  legend.append("label").text(d => d);

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", `translate(${margins.left},${margins.top})`);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .ticks(ticksX)
    .tickFormat(d => "$" + d + "B");

  // Render axes to chart.
  chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  // Render grid to chart.

  chartElement
    .append("g")
    .attr("class", "x grid")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(
      xAxis
        .tickSize(-chartHeight, 0, 0)
        .tickFormat("")
    );

  // Render bars to chart.
  var group = chartElement
    .selectAll(".group")
    .data(config.data)
    .enter()
    .append("g")
    .attr("class", d => "group " + classify(d[labelColumn]))
    .attr(
      "transform",
      (d, i) => {
        let amount = i * (barHeight + barGap)+ spacer * Math.max(0,i-3);        
        return "translate(0," + amount + ")"}
    );

  group
    .selectAll("rect")
    .data(d => d.values)
    .enter()
    .append("rect")
    .attr("x", d => (d.x0 < d.x1 ? xScale(d.x0) : xScale(d.x1)))
    .attr("width", d => Math.abs(xScale(d.x1) - xScale(d.x0)))
    .attr("height", barHeight)
    .style("fill", d => colorScale(d[nameColumn]))
    .attr("class", d => classify(d[nameColumn]));

  // Render bar values.

  
  // render little lines
    group
      .append("g")
      .attr("class", "value line-group")
      .append("line")      
        .attr("class", "line")
        .attr("x1", d => xScale(d.total) + 47)
        .attr("x2", d => xScale(d.total) + totalGap/2)
        .attr("y1", barHeight / 2 + 5)
        .attr("y2", barHeight / 2 + 5);

    //Render total values
  group
    .append("g")
    .attr("class", "value preTotal")
    .append("text")
      .text(d => {
        return "$" + (d.total - d.values[d.values.length - 1].val).toFixed(1) + "B"
      })
      .attr("x", d => xScale(d.total) + labelWidthEnd)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 - 12);

  group
    .append("g")
    .attr("class", "value preTotal label")
    .append("text")
      .text("to date")    
      .attr("x", d => xScale(d.total) + labelWidthEnd + 3)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 - 12);

  group
    .append("g")
    .attr("class", "value october-2023-requested")
    .append("text")
      .text(d => "+ $" + d.values[d.values.length - 1].val + "B")
      .attr("x", d => xScale(d.total) + labelWidthEnd)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 + 2);

  group
    .append("g")
    .attr("class", "value label october-2023-requested ")
    .append("text")
      .text("requested")
      .attr("x", d => xScale(d.total) + labelWidthEnd + 3)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 + 2);

  group
    .append("g")
    .attr("class", "value total")
    .append("text")
      .text(d => "$" + d.total + "B")
      .attr("x", d => xScale(d.total) + labelWidthEnd)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 + 16);

  group
    .append("g")
    .attr("class", "value total label")
    .append("text")
      .text("total")
      .attr("x", d => xScale(d.total) + labelWidthEnd + 3)
      .attr("dx", valueGap)
      .attr("dy", barHeight / 2 + 16);

  // Render 0-line.
  if (min < 0) {
    chartElement
      .append("line")
      .attr("class", "zero-line")
      .attr("x1", xScale(0))
      .attr("x2", xScale(0))
      .attr("y1", 0)
      .attr("y2", chartHeight);
  }

  chartElement
      .append("line")
      .attr("class", "dotter-line")
      .attr("x1", 0 - margins.left + 5 )
      .attr("x2", chartWidth + 5)
      .attr("y1", 4 * (barHeight + barGap) + spacer/2-2)
      .attr("y2", 4 * (barHeight + barGap) + spacer/2-2)

  // Render bar labels.
  chartWrapper
    .append("ul")
    .attr("class", "labels")
    .attr(
      "style",
      formatStyle({
        width: labelWidth + "px",
        top: margins.top + "px",
        left: "0"
      })
    )
    .selectAll("li")
    .data(config.data)
    .enter()
    .append("li")
    .attr("style", (d, i) =>
      formatStyle({
        width: labelWidth + "px",
        height: barHeight + "px",
        left: "0px",
        top: (i * (barHeight + barGap) + spacer * Math.max(0,i-3)) + "px;"
      })
    )
    .attr("class", d => classify(d[labelColumn]))
    .append("span")
    .text(d => d[labelColumn]);
};
